/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, H2, Text, Flex, Button, Label } from "ui-components";
import DropdownField from "components/FormFields/DropdownField";
import FormattedMessage from "components/FormattedMessage/index";
import { ChevronDown, ChevronUp } from "components/Icons";
import get from "lodash/get";
import {
  buttonThemes,
  COLORS,
  getButtonColorVariant
} from "ui-components/theme";
import { isEmpty } from "lodash";
import { gotoUrl } from "utils/helpers";
import CompatibleMessage from "./CompatibleMessage/index";

const DeviceCompatibilityChecker = props => {
  const {
    headerTitle,
    subTitle,
    dropdownBrandProps,
    dropdownModelProps,
    isEsim,
    hideAlerts,
    esimDesc,
    accordionTitle,
    mobileBrandList,
    noteOnPhones,
    changeField,
    addOns,
    handleSelectAddon,
    redirectUrl,
    preselected5GAddon,
    is5GAddonSelected,
    selectedMobileDeviceBrand,
    filteredMobileDeviceModels,
    selectedMobileDevice,
    planName
  } = props;

  const [showDetails, setShowDetails] = useState(false);
  const [ctaHovered, setCtaHovered] = useState(false);

  const buttonTheme = get(props?.themeColors, "button", {});
  const buttonVariant = "primary";
  const buttonStyles = getButtonColorVariant(buttonTheme, buttonVariant);
  const ctaTheme = get(props?.themeColors, "cta", buttonThemes.blue);
  const errorColor = get(props?.themeColors, "error", COLORS.red[5]);
  const successColor = get(props?.themeColors, "success", COLORS.green[6]);
  const ctaColor = get(ctaTheme, ctaHovered ? "hoverColor" : "color");
  const addOn5gIndex = addOns?.findIndex(addon => addon.name === "5G");
  const isFamilyPlan = planName === "CirclesParent";

  useEffect(() => {
    if (
      !isEmpty(selectedMobileDevice) &&
      !selectedMobileDevice["5g"] &&
      !preselected5GAddon &&
      !hideAlerts
    ) {
      updateAddons(true, false);
    }
  }, [selectedMobileDevice]);

  const updateAddons = (enable5gAddon, select5gAddon) => {
    if (addOn5gIndex !== -1) {
      addOns[addOn5gIndex] = {
        ...addOns[addOn5gIndex],
        selected: select5gAddon
      };
      changeField("addOns", addOns);
      !select5gAddon
        ? handleSelectAddon(addOns[addOn5gIndex].id, false)
        : handleSelectAddon(addOns[addOn5gIndex].id, true);
    }
  };

  const handleBtnClick = () => {
    if (selectedMobileDevice) {
      if (isEsim) {
        if (!selectedMobileDevice?.esim) {
          if (redirectUrl) {
            gotoUrl("https://www.circles.life/sg/plans/");
          } else {
            changeField("sim_type", "physicalsim");
          }
        } else if (!get(selectedMobileDevice, "5g")) {
          gotoUrl("https://www.circles.life/sg/plans/");
        }
      } else {
        if (!get(selectedMobileDevice, "5g")) {
          gotoUrl("https://www.circles.life/sg/plans/");
        }
      }
    }
  };

  return (
    <Box
      id="addon-toggle"
      style={
        !(is5GAddonSelected || selectedMobileDeviceBrand)
          ? isEsim
            ? {}
            : { display: "none" }
          : {}
      }
    >
      {isEsim ? (
        <>
          <Text
            mb={4}
            size="md"
            lineHeight="1.2"
            style={{ whiteSpace: "pre-line" }}
          >
            <FormattedMessage id={esimDesc} />
          </Text>
        </>
      ) : (
        <>
          <H2 mb={4} mt={4}>
            <FormattedMessage id={headerTitle} />
          </H2>
          <Text
            mb={4}
            size="md"
            lineHeight="1.2"
            style={{ whiteSpace: "pre-line" }}
          >
            <FormattedMessage id={subTitle} />
          </Text>
        </>
      )}

      <DropdownField
        {...dropdownBrandProps}
        {...(dropdownBrandProps?.data || {})}
        themeColors={props?.themeColors}
        options={mobileBrandList || []}
        onChange={() => changeField("select_mobile_device_model", null)}
      />

      <DropdownField
        {...dropdownModelProps}
        {...(dropdownBrandProps?.data || {})}
        themeColors={props?.themeColors}
        options={(filteredMobileDeviceModels?.models || []).map(item => {
          return { label: item.name, value: item.name };
        })}
      />

      {isEsim && accordionTitle && (
        <>
          <Flex
            mb={4}
            mt={4}
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            onClick={() => setShowDetails(!showDetails)}
            onMouseOver={() => setCtaHovered(true)}
            onMouseOut={() => setCtaHovered(false)}
          >
            <FormattedMessage html id={accordionTitle}>
              {msg => (
                <span style={{ color: ctaColor, fontWeight: "bold" }}>
                  {msg}
                </span>
              )}
            </FormattedMessage>
            <Button variant="closeButton" as="a">
              {showDetails ? (
                <ChevronUp size={"30px"} color={ctaColor} />
              ) : (
                <ChevronDown size={"30px"} color={ctaColor} />
              )}
            </Button>
          </Flex>
          <Box>
            {showDetails && (
              <Label sx={{ fontWeight: "normal !important" }} my={4} mb={4}>
                <FormattedMessage html id={noteOnPhones} />
              </Label>
            )}
          </Box>
        </>
      )}

      <Box mt={4} mb={4}>
        {!isEmpty(selectedMobileDevice) && isEsim && (
          <Box>
            {isEsim && !hideAlerts && (
              <CompatibleMessage
                iconCondition={selectedMobileDevice?.esim}
                messageCondition={
                  selectedMobileDevice?.esim
                    ? "device_esim_compatible"
                    : "device_esim_not_compatible"
                }
                errorColor={errorColor}
                successColor={successColor}
              />
            )}

            {!selectedMobileDevice?.esim && isEsim && !hideAlerts && (
              <FormattedMessage id={"get_psim"}>
                {msg => (
                  <Flex justifyContent="center">
                    <Button
                      variant={buttonVariant}
                      sx={buttonStyles}
                      onClick={handleBtnClick}
                      width="40%"
                    >
                      {msg}
                    </Button>
                  </Flex>
                )}
              </FormattedMessage>
            )}

            {preselected5GAddon &&
              !get(selectedMobileDevice, "5g") &&
              selectedMobileDevice?.esim && (
                <CompatibleMessage
                  iconCondition={get(selectedMobileDevice, "5g")}
                  messageCondition={"device_5g_not_compatible"}
                  successColor={successColor}
                  errorColor={errorColor}
                />
              )}

            {preselected5GAddon &&
              !isFamilyPlan &&
              !get(selectedMobileDevice, "5g") &&
              selectedMobileDevice?.esim && (
                <FormattedMessage id={"try_4g_plans"}>
                  {msg => (
                    <Flex justifyContent="center">
                      <Button
                        variant={buttonVariant}
                        sx={buttonStyles}
                        onClick={handleBtnClick}
                        width="40%"
                      >
                        {msg}
                      </Button>
                    </Flex>
                  )}
                </FormattedMessage>
              )}
          </Box>
        )}

        {!isEmpty(selectedMobileDevice) && !isEsim && !hideAlerts && (
          <Box>
            {!isEsim && (
              <CompatibleMessage
                iconCondition={get(selectedMobileDevice, "5g")}
                messageCondition={
                  get(selectedMobileDevice, "5g")
                    ? "device_5g_compatible"
                    : isFamilyPlan
                    ? "device_5g_not_compatible_family_plan"
                    : "device_5g_not_compatible"
                }
                errorColor={errorColor}
                successColor={successColor}
              />
            )}

            {preselected5GAddon &&
              !get(selectedMobileDevice, "5g") &&
              !isFamilyPlan && (
                <FormattedMessage id={"try_4g_plans"}>
                  {msg => (
                    <Flex justifyContent="center">
                      <Button
                        variant={buttonVariant}
                        sx={buttonStyles}
                        onClick={handleBtnClick}
                        width="40%"
                      >
                        {msg}
                      </Button>
                    </Flex>
                  )}
                </FormattedMessage>
              )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

DeviceCompatibilityChecker.defaultProps = {
  headerTitle: "check_5g_device_compatibility",
  subTitle: "ensure_5g_ready"
};

DeviceCompatibilityChecker.propTypes = {
  headerTitle: PropTypes.string.isRequired
};

export default DeviceCompatibilityChecker;
